<template>
  <div class="app-container">
    <div class="bar"></div>
    <div class="msg">
      <table border="0" cellspacing="0" cellpadding="0">
        <tr>
          <th>用户名</th>
          <td>{{ msg.real_name }}</td>
        </tr>
        <tr>
          <th>用户头像</th>
          <td>
            <el-image
              style="width: 100px; height: 100px"
              :src="msg.avatar"
              error="暂无头像"
              :preview-src-list="[msg.avatar]"
            >
              <div slot="error" class="el-image__error">暂无头像</div>
            </el-image>
          </td>
        </tr>
        <tr>
          <th>手机</th>
          <td>{{ msg.mobile }}</td>
        </tr>
        <tr>
          <th>邮箱</th>
          <td>{{ msg.email }}</td>
        </tr>
        <tr>
          <th>性别</th>
          <td>{{ ["保密", "男", "女"][msg.sex] }}</td>
        </tr>
        <tr>
          <th>地区</th>
          <td>{{ msg.address }}</td>
        </tr>
        <tr>
          <th>注册时间</th>
          <td>{{ msg.create_time }}</td>
        </tr>
        <tr>
          <th>最后登录日期</th>
          <td>{{ msg.last_login_time }}</td>
        </tr>
        <tr>
          <th>状态</th>
          <td>{{ ["", "正常", "禁用"][msg.status] }}</td>
        </tr>
        <tr>
          <th>密码</th>
          <td>
            <div class="m-input f-flex">
              <el-input size="small" type="password" v-model="pass" placeholder="请输入密码" style="margin-right: 10px;"></el-input>
              <el-button size="small" type="primary" @click="handleChangePwd">确定修改</el-button>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="back">
      <el-button type="danger" @click="tobanUser">{{ ["", "禁用", "解禁"][msg.status] }}</el-button>

      <el-button @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>

<script>
import { getUserDetail, banUser, updatePwd } from "@/api/user.js";
export default {
  data() {
    return {
      querys: {},
      msg: {},
      pass: "", // 密码
    };
  },
  mounted() {
    this.querys = this.$route.query;
    if (this.querys.uuid) {
      this.getDetail(this.querys.uuid);
    } else {
      this.$message.error("未识别的用户");
    }
  },
  methods: {
    tobanUser() {
      const ops = ["", "禁用", "解禁"][this.msg.status];
      this.$confirm("确定要" + ops + "该用户吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.userOption();
        })
        .catch(() => {});
    },
    async getDetail(id) {
      const res = await getUserDetail(id);
      if (res) {
        this.msg = res;
      }
      console.log(res);
    },
    async userOption() {
      const res = await banUser(this.querys.uuid);
      console.log(res);
      if (res) {
        this.$message.success("操作成功");
        this.getDetail(this.querys.uuid);
      } else {
        this.$message.error("操作失败");
      }
    },
    // 修改密码
    async handleChangePwd() {
      if (!this.pass) return this.$message.error("请输入密码");
      const res = await updatePwd(this.querys.uuid, { password: this.pass });
      if (!res) return;
      this.$message.success("修改成功");
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.msg {
  table {
  }
  th {
    width: 150px;
    padding-right: 20px;
    line-height: 40px;
    text-align: right;
  }
}
.back {
  text-align: center;
}
</style>
